/* Copyright (c) 2018 Scaper */

import { parse, stringify } from "query-string";
import { RouteComponentProps } from "react-router";
import { APP_PATH } from "../appPath";

export interface ISignInRouteParams {
    from?: string;
}

export const SIGN_IN_PATH = `${APP_PATH}/sign-in`;

export const SignInPath = {
    of: (params?: ISignInRouteParams) => {
        const queryString = params != null ? `?${stringify(params)}` : "";
        return `${SIGN_IN_PATH}${queryString}`;
    },
    parse: (props: RouteComponentProps<ISignInRouteParams>) => {
        const pathParams = props.match.params;
        const queryParams = parse(props.location.search);
        return { ...pathParams, ...queryParams };
    },
};
